import { render, staticRenderFns } from "./EditProjectTargets.vue?vue&type=template&id=9d744b3a&scoped=true"
import script from "./EditProjectTargets.vue?vue&type=script&lang=js"
export * from "./EditProjectTargets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d744b3a",
  null
  
)

export default component.exports